import { useEffect, useState } from 'react';
import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import Calling from './api/Calling';
import { ToastContainer } from 'react-toastify';
import Navbar1 from './components/Navbar/Navbar1';
import Navbar2 from './components/Navbar/Navbar2';
import Login from './admin/Login/Login';
import Page404 from './components/page/Page404';
import Logout from './admin/Login/Logout';
import Error from './admin/Login/Error';
import Home from './admin/Home';
import NewPw from './admin/Login/NewPw';
import ForgetPw from './admin/Login/ForgetPw';
import ForgetPwOtp from './admin/Login/ForgetPwOtp';
import LoginOtp from './admin/Login/LoginOtp';
import Profile from './admin/Profile/Profile';
import MobileAdd from './admin/Mobile/MobileAdd';
import Mobile from './admin/Mobile/Mobile';
import NativeAds from './admin/Ads/NativeAds/NativeAds';
import FullScreenAds from './admin/Ads/FullScreenAds/FullScreenAds';
import BannerAds from './admin/Ads/BannerAds/BannerAds';
import OpenAds from './admin/Ads/OpenAds/OpenAds';
import RewardAds from './admin/Ads/RewardAds/RewardAds';
import Controler from './admin/Controler/Controler';
import UserInfo from './admin/User/UserInfo';
import AllUserLogin from './admin/User/AllUserLogin';
import User from './admin/User/User';
import ApiConfig from './admin/Mobile/ApiConfig';
import Terms from './admin/Policy/Terms';
import Policy from './admin/Policy/Policy';
import Notification from './admin/Controler/Notification';
import ShowBox from './admin/Controler/ShowBox';
import ViewsDashbord from './admin/ViewsDashbord';
import InHouseAds from './admin/Ads/InHouseAds/InHouseAds';
import EditeInHouseAds from './admin/Ads/InHouseAds/EditeInHouseAds';
import AdsTrack from './admin/Ads/AdsTrack/AdsTrack';
import ShowBoxTrack from './admin/Controler/ShowBoxTrack';
import AdsTxtEditor from './admin/Controler/AdsTxtEditor';
import WhiteListNumber from './admin/Mobile/WhiteListNumber';
import RewardFsAds from './admin/Ads/RewardFsAds/RewardFsAds';
import RateLimit from './admin/Controler/RateLimit';
import BugReport from './admin/Controler/BugReport';
import AutoNotification from './admin/Controler/AutoNotification';
import AutoNotificationTemp from './admin/Controler/AutoNotificationTemp';
import IosNativeAds from './admin/Ads/ios/IosNavtiveAds/IosNativeAds';
import IosFullScreenAds from './admin/Ads/ios/IosFullScreenAds/IosFullScreenAds';
import IosBannerAds from './admin/Ads/ios/IosBannerAds/IosBannerAds';
import IosOpenAds from './admin/Ads/ios/IosOpenAds/IosOpneAds';
import IosRewardAds from './admin/Ads/ios/IosRewardAds/IosRewardAds';
import IosPolicy from './admin/Policy/IosPolicy';
import IosTerms from './admin/Policy/IosTerms';
import JsonManager from './admin/UI/JsonManager';
import IosRewardFsAds from './admin/Ads/ios/IosRewardFsAds/IosRewardFsAds';
import INSPACTLOCK from './components/INSPACTLOCK';
import Plan from './admin/Plan/Plan';
import PlanHistory from './admin/Plan/PlanHistory';
import Client from './client/Client';
import Referral from './admin/User/Referral';
import ReferralPlan from './admin/Referral/ReferralPlan';
import ReferralPlanHistory from './admin/Referral/ReferralPlanHistory';
import AccountDeleteRequest from './client/AccountDeleteRequest';
import UserDeleteRequest from './admin/User/UserDeleteRequest';


function App() {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const navigate = useNavigate();

  const handleLoginStatusChange = (status) => {
    if (status) {
      setIsAuthorized(true);
    }
  };

  const handleLogout = () => {
    setIsAuthorized(false);
    localStorage.removeItem('admin_trucaller');
    navigate('/admin/panel/login');
  };

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const adminToken = localStorage.getItem('admin_trucaller');

        if (!adminToken) {
          setIsAuthorized(false);
          return;
        }

        const resp = await Calling.AdminAuthCheck();
        setIsAuthorized(resp.status);
      } catch (error) {
        console.log(error);
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  // Premium Loading State
  if (isAuthorized === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-100">
        <div className="flex flex-col items-center gap-6">
          {/* Animated Logo/Loader */}
          <div className="relative">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-main-blue to-blue-600 
                            shadow-xl shadow-main-blue/30 flex items-center justify-center
                            animate-pulse">
              <div className="w-8 h-8 border-3 border-white border-t-transparent rounded-full animate-spin" />
            </div>
            {/* Decorative rings */}
            <div className="absolute -inset-4 rounded-3xl border-2 border-main-blue/10 animate-ping"
              style={{ animationDuration: '2s' }} />
            <div className="absolute -inset-8 rounded-3xl border border-main-blue/5" />
          </div>
          <div className="text-center">
            <p className="text-gray-700 font-semibold text-lg">Loading Dashboard</p>
            <p className="text-gray-400 text-sm mt-1">Please wait a moment...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50/50 custom-scrollbar ">
      {/* Toast Notifications */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastClassName="!rounded-xl !shadow-xl !border !border-gray-100"
        bodyClassName="!text-sm"
      />

      {/* Inspect Lock */}
      <INSPACTLOCK />

      {isAuthorized ? (
        <>
          {/* Top Navbar - Contains Logo */}
          <Navbar2 />

          {/* Sidebar - Below top navbar */}
          <Navbar1 />

          {/* Main Content Area */}
          <main className="md:ml-[70px] pt-[72px] min-h-screen transition-all duration-300">
            {/* Subtle Background Effects */}
            <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
              <div className="absolute -top-40 -right-40 w-96 h-96 bg-main-blue/5 rounded-full blur-3xl" />
              <div className="absolute top-1/3 -left-40 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl" />
              <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-purple-500/3 rounded-full blur-3xl" />
            </div>

            <div className="p-4">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Logout" element={<Logout onLogout={handleLogout} />} />
                <Route path='/profile' element={<Profile />} />

                {/* Native Ads */}
                <Route path='/manage/ads/nativeAds/add' element={<NativeAds />} />

                {/* FullScreenAds */}
                <Route path='/manage/ads/fullScreenAds/add' element={<FullScreenAds />} />

                {/* Banner Ads */}
                <Route path='/manage/ads/bannerAds/add' element={<BannerAds />} />

                {/* Open Ads */}
                <Route path='/manage/ads/openAds/add' element={<OpenAds />} />

                {/* Reward Ads */}
                <Route path='/manage/ads/rewardAds/add' element={<RewardAds />} />

                {/* RewardFs Ads */}
                <Route path='/manage/ads/rewardFsAds/add' element={<RewardFsAds />} />

                {/* Tracks Ads */}
                <Route path='/manage/adstrack' element={<AdsTrack />} />

                {/* InHouseAds */}
                <Route path='/manage/ads/inHouseAds/add' element={<InHouseAds />} />
                <Route path='/manage/ads/inHouseAds/edit/:id' element={<EditeInHouseAds />} />

                {/* Controller */}
                <Route path='/controller' element={<Controler />} />
                <Route path='/manage/mobile/api-config' element={<ApiConfig />} />

                {/* User Login */}
                <Route path='/manage/user/login/all/data' element={<AllUserLogin />} />

                {/* User */}
                <Route path='/manage/user/all/data' element={<User />} />
                <Route path='/manage/user/all/info/:id' element={<UserInfo />} />
                <Route path='/manage/user/all/delete' element={<UserDeleteRequest />} />

                {/* Mobile */}
                <Route path='/manage/mobile/' element={<Mobile />} />
                <Route path='/manage/mobile/add' element={<MobileAdd />} />
                <Route path='/manage/mobile/whitelistnumber' element={<WhiteListNumber />} />

                {/* Ios Ads */}
                <Route path='/manage/ads/ios/nativeAds/add' element={<IosNativeAds />} />
                <Route path='/manage/ads/ios/fullScreenAds/add' element={<IosFullScreenAds />} />
                <Route path='/manage/ads/ios/bannerAds/add' element={<IosBannerAds />} />
                <Route path='/manage/ads/ios/openAds/add' element={<IosOpenAds />} />
                <Route path='/manage/ads/ios/rewardAds/add' element={<IosRewardAds />} />
                <Route path='/manage/ads/ios/rewardAdsFs/add' element={<IosRewardFsAds />} />

                {/* Show Box */}
                <Route path='/manage/mobile/showbox/' element={<ShowBox />} />
                <Route path='/manage/mobile/bugreport' element={<BugReport />} />
                <Route path='/manage/showboxanalytic' element={<ShowBoxTrack />} />

                {/* Policy */}
                <Route path='/policy' element={<Policy />} />
                <Route path='/policy/terms' element={<Terms />} />

                {/* Policy Ios*/}
                <Route path='/policy/ios' element={<IosPolicy />} />
                <Route path='/policy/terms/ios' element={<IosTerms />} />

                {/* Notification */}
                <Route path='/notification' element={<Notification />} />
                <Route path='/manage/mobile/autonotification' element={<AutoNotification />} />
                <Route path='/manage/mobile/autonotificationtemp' element={<AutoNotificationTemp />} />

                <Route path='/manage/UI/jsonmanager' element={<JsonManager />} />

                {/* Plan */}
                <Route path='/manage/plan' element={<Plan />} />
                <Route path='/manage/plan/history' element={<PlanHistory />} />

                {/* Referral */}
                <Route path='/manage/user/referral/all/data' element={<Referral />} />
                <Route path='/manage/plan/referral/history' element={<ReferralPlanHistory />} />
                <Route path='/manage/plan/referral' element={<ReferralPlan />} />

                {/* Ads Txt */}
                <Route path='/manage/ads/txt' element={<AdsTxtEditor />} />

                {/* View Dashboard */}
                <Route path="/views/dashboard/:id" element={<ViewsDashbord />} />

                <Route path='/manage/ratelimit' element={<RateLimit />} />

                <Route path='/web/delete/user' element={<AccountDeleteRequest />} />

                <Route path="*" element={<Error />} />
              </Routes>
            </div>
          </main>
        </>
      ) : (
        <Routes>
          <Route path='/admin/panel/login' element={<Login onLogin={handleLoginStatusChange} />} />
          <Route path='/admin/panel/login/otp' element={<LoginOtp onLogin={handleLoginStatusChange} />} />
          <Route path='/admin/panel/forgetpw' element={<ForgetPw />} />
          <Route path='/admin/panel/forget/otp' element={<ForgetPwOtp />} />
          <Route path='/admin/panel/new/password' element={<NewPw />} />
          <Route path='/web/delete/user' element={<AccountDeleteRequest />} />
          <Route path='*' element={<Client />} />
        </Routes>
      )}
    </div>
  );
}

export default App;